import { LinkButton } from "@bca/ui-library";
import styled from "styled-components";

export const HoverableLinkButton = styled(LinkButton)`
  &:hover {
    text-decoration: underline;
  }
`;
